import { render, staticRenderFns } from "./setup_login.vue?vue&type=template&id=c5e0ee06"
import script from "./setup_login.vue?vue&type=script&lang=js"
export * from "./setup_login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports